import { useNavigate } from 'react-router-dom';
import { KindIcon } from './KindIcon';
import { colors, cardStyle } from '../theme';
import { CREATE_KIND_CONFIG } from '../types';
import type { CreateKind } from '../types';

const CARDS: { kind: CreateKind; description: string }[] = [
  { kind: 'frontend', description: 'Next.js, React, Vue and more' },
  { kind: 'backend', description: 'APIs, microservices and more' },
  { kind: 'fullstack', description: 'React frontend + NestJS backend, wired together' },
  { kind: 'compose', description: 'Paste a docker-compose file — live in seconds' },
  { kind: 'ai-agent', description: 'LLM powered agents with tools' },
  { kind: 'worker', description: 'Background jobs and processing' },
  { kind: 'scheduled-job', description: 'Cron jobs, schedulers and automation' },
];

function BuildCard({ kind, description }: { kind: CreateKind; description: string }) {
  const navigate = useNavigate();
  const config = CREATE_KIND_CONFIG[kind];
  return (
    <div
      style={{
        ...cardStyle,
        padding: 20,
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
      }}
    >
      <KindIcon kind={kind} />
      <div>
        <div style={{ fontWeight: 600, fontSize: 15, color: colors.text }}>{config.title}</div>
        <div style={{ fontSize: 13, color: colors.textMuted, marginTop: 4 }}>{description}</div>
      </div>
      <button
        type="button"
        onClick={() => navigate(config.route)}
        aria-label={`Create ${config.title}`}
        style={{
          marginTop: 'auto',
          border: `1px solid ${colors.border}`,
          background: colors.surface,
          color: colors.primary,
          borderRadius: 8,
          padding: '8px 0',
          fontSize: 14,
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        Create
      </button>
    </div>
  );
}

export function CreateKindGrid() {
  return (
    <div
      style={{
        display: 'grid',
        // Fixed track sizing (unlike flexbox's flex-grow) means a lone
        // leftover card on the last row keeps the same width as every
        // other card instead of stretching to fill the row — real bug
        // found live with 6 cards wrapping 5-then-1.
        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
        gap: 16,
      }}
    >
      {CARDS.map((c) => (
        <BuildCard key={c.kind} kind={c.kind} description={c.description} />
      ))}
    </div>
  );
}
